import React from 'react';
import { Modal } from 'react-bootstrap';

const PaymentCancleConfirmationModal = ({ show, onConfirm, onCancel }) => {
  return (
    <>
      <Modal
        size='md'
        centered
        show={show}
        className={`modal-dialog-center sent-tip-modal createstorymodal"}`}
      >
        <Modal.Body className='p-4'>
          <div className='modal-item-padding d-flex flex-column justify-content-center align-items-center gap-1'>
            <h5 className='title fw-bold text-center'>Are you sure you want to close this payment window?</h5>
            <p className='text-center text-muted mb-0'>Make sure you’ve completed or saved the payment information before closing.</p>
          </div>
          <div className='p-2 d-flex flex-row align-items-center gap-5'>
            <div
              className='mt-3 p-3 w-100 d-flex payment-cancle-confirm-button'
              role={'button'}
              aria-label='yes'
              onClick={onConfirm}
            >
              <span>Close</span>
            </div>
            <div
              className='mt-3 p-3 w-100 d-flex payment-cancle-button'
              role={'button'}
              aria-label='goBack'
              onClick={onCancel}
            >
              <span>Go Back</span>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PaymentCancleConfirmationModal;
